import { usePageTitle } from '../../hooks/usePageTitle';
import { PRACTICE_CREATE_GROUPS } from '../../components/accounts/practice/details/fieldDefinitions';
import { DetailGroupCard } from '../../components/accounts/practice/details/DetailGroupCard';
import { PracticeFormHeader } from '../../components/accounts/practice/create/PracticeFormHeader';
import { DiscardPracticeConfirmModal } from '../../components/accounts/practice/create/DiscardPracticeConfirmModal';
import { usePracticeCreateForm } from '../../components/accounts/practice/create/usePracticeCreateForm';

// Create-only counterpart to PracticeDetail's Details tab - same
// DetailGroupCard/DetailField rendering and stacked full-width card layout,
// but PRACTICE_CREATE_GROUPS drops the risk group (set post-creation from
// the Details tab, DB default 'normal'). Editing lives entirely on the
// Details tab of the practice this creates (see usePracticeCreateForm's
// on-success navigate).
export function PracticeCreatePage() {
    usePageTitle('New practice');
    const form = usePracticeCreateForm();

    return (
        <div className="flex flex-col h-full overflow-hidden bg-gray-100">
            <PracticeFormHeader
                isDirty={form.isDirty}
                isSaving={form.isSaving}
                canCreate={form.canCreate}
                onNavigate={form.guardedNavigate}
                onCancel={() => form.guardedNavigate('/accounts/practices')}
                onCreate={form.onCreate}
            />
            <div className="flex-1 min-h-0 overflow-y-auto scrollbar-hide px-8 pb-8">
                <div className="flex flex-col gap-4 pt-2">
                    {PRACTICE_CREATE_GROUPS.map((group) => (
                        <DetailGroupCard
                            key={group.id}
                            group={group}
                            values={form.values}
                            fieldState={form.fieldState}
                            fieldError={form.fieldError}
                            disabled={form.isSaving}
                            showRequiredMarkers
                            onFieldChange={form.onFieldChange}
                        />
                    ))}
                </div>
            </div>
            {form.showDiscardModal && (
                <DiscardPracticeConfirmModal
                    onKeepEditing={form.cancelDiscardNavigation}
                    onDiscard={form.confirmDiscardNavigation}
                />
            )}
        </div>
    );
}
